import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.hasLoaded)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(`api-sport api-sport-${_ctx.siteName}`)
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.comp), {
          competitionId: _ctx.competitionId,
          seasonId: _ctx.seasonId
        }, null, 8, ["competitionId", "seasonId"]))
      ], 2))
    : _createCommentVNode("", true)
}